import { GOAL_TARGET_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import ObjectDefinitionRecord from 'customer-data-filters-ui/objectDefinitionProvider/ObjectDefinitionRecord';
const GoalTarget = ObjectDefinitionRecord({
  enableAsAssociatedType: false,
  hasAccess: (_, hasScope) => hasScope('goals-read'),
  objectTypeId: GOAL_TARGET_ID
});
export default GoalTarget;